/** Cobertura de órdenes de inscripción por participante (re-gate #129,
 * bloqueante 4).
 *
 * Una orden multi-categoría cubre por `items` divisiones de participantes que
 * NO son su ancla (`participant_id`). Indexar pagos solo por el ancla dejaba
 * al participante cubierto como "Pendiente de pago" aunque la orden que cubre
 * su división ya esté pagada. La cobertura correcta es items ∪ ancla.
 */

export type CoverageOrderLike = {
  status: string;
  participant_id: number | null;
  items?: { participant_id: number | null }[] | null;
};

/** Prioridad cuando más de una orden cubre al mismo participante (p.ej. una
 * cancelada vieja + la vigente): paid > pending > terminales. */
function coverageRank(order: CoverageOrderLike): number {
  if (order.status === "paid") return 3;
  if (order.status === "pending") return 2;
  return 1;
}

/** Mapa participant_id → orden que cubre su inscripción (por ancla O por
 * item), prefiriendo la orden viva (paid/pending) sobre terminales. */
export function ordersByCoveredParticipant<T extends CoverageOrderLike>(
  orders: T[],
): Map<number, T> {
  const map = new Map<number, T>();
  orders.forEach((order) => {
    const coveredIds = new Set<number>();
    if (order.participant_id != null) coveredIds.add(order.participant_id);
    (order.items ?? []).forEach((item) => {
      if (item.participant_id != null) coveredIds.add(item.participant_id);
    });
    coveredIds.forEach((participantId) => {
      const current = map.get(participantId);
      if (!current || coverageRank(order) > coverageRank(current)) {
        map.set(participantId, order);
      }
    });
  });
  return map;
}
